// removes element if already present in the array
// adds if not present
export default (array, item) =>
  array
    .filter(elem => elem !== item)
    .concat(array.includes(item) ? [] : [item]);
